import { Inter } from 'next/font/google';
import localFont from 'next/font/local';
import React from 'react';

export const interFont = Inter({ subsets: ['latin'] });

const gilroyFont = localFont({
  src: [
    {
      path: './local-fonts/Gilroy-SemiBold.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: './local-fonts/Gilroy-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
  ],
});

export const Fonts: React.FC = () => {
  return (
    <style jsx global>{`
      :root {
        --font-family-heading: ${gilroyFont.style.fontFamily};
        --font-family-body: ${interFont.style.fontFamily};
      }
    `}</style>
  );
};
